import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=fe734df2&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe734df2",
  null
  
)

export default component.exports